import styled from 'styled-components';
import { themeColor, themeSize } from '../../../theme/getters';
import { Content } from '../../../theme/layout';
import { spacedHeading, paragraph } from '../../../theme/typography';
import { Button } from '../button';
import { media } from '../../../theme/media';

export const ContentWrapper = styled(Content)`
  padding-top: 56px;
  padding-bottom: 104px;
  ${media.tablet`
    padding-bottom: 80px;
  `}
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const CancellationTitle = styled.h1`
  ${spacedHeading};
`;

export const MainWrapper = styled.div`
  ${paragraph};
  margin: ${themeSize('contentVerticalMargin')}px 0 0;

  max-width: 636px;
  text-align: left;
`;

export const PolicyText = styled.p`
  margin: 0 0;
`;

export const SubTitle = styled.h2`
  ${spacedHeading};
  color: ${themeColor('gray')};
  margin: 32px 0 24px;
`;

export const UnderstandButton = styled(Button)`
  margin-top: 56px;
  ${media.tablet`
    margin-top: 64px;
  `};
  max-width: 700px;
`;
